import classNames from 'classnames';
import type { JSX } from 'react';

import styles from './Badge.module.css';

function Badge({
  className,
  badgeType,
  indicator,
  children,
  size,
  ...props
}: React.ComponentProps<'span'> & {
  /**
   * Visual style. Omit for the default filled badge (neutral background + color).
   * `ghost` renders with no background — only the colored dot and label.
   */
  badgeType?: 'destructive' | 'outline' | 'secondary' | 'ghost';
  indicator?: 'blue' | 'green' | 'orange' | 'cyan' | 'red';
  className?: string;
  size?: 'small';
}): JSX.Element {
  return (
    <span
      className={classNames(
        styles.Badge,
        {
          [styles[badgeType]]: badgeType,
          ...(indicator && { [styles[indicator]]: true }),
          ...(size && { [styles[size]]: true }),
        },
        className,
      )}
      {...props}
    >
      {indicator && <span className={styles.Dot} aria-hidden="true" />}
      {children}
    </span>
  );
}

export { Badge };
